"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ponte-dell-olio": {
    "ed4dd1d2": [{
      "hkey": "38a4dc9a",
      "slug": "ponte-dell-olio",
      "name": "Ponte dell'Olio",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria-del-rivo": [{
      "hkey": "38a4dc9a",
      "slug": "ponte-dell-olio",
      "name": "Ponte dell'Olio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "da3e6d5a": [{
      "hkey": "38a4dc9a",
      "slug": "ponte-dell-olio",
      "name": "Ponte dell'Olio",
      "primary": true,
      "skipSearch": false
    }],
    "sarmata": [{
      "hkey": "38a4dc9a",
      "slug": "ponte-dell-olio",
      "name": "Ponte dell'Olio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a188e1f9": [{
      "hkey": "15ebf441",
      "slug": "torrano",
      "name": "Torrano",
      "primary": true,
      "skipSearch": false
    }],
    "torrano-veggiola": [{
      "hkey": "15ebf441",
      "slug": "torrano",
      "name": "Torrano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1e876ef5": [{
      "hkey": "cb16e848",
      "slug": "zaffignano-la-fratta",
      "name": "Zaffignano-La Fratta",
      "primary": true,
      "skipSearch": false
    }],
    "zaffignano": [{
      "hkey": "cb16e848",
      "slug": "zaffignano-la-fratta",
      "name": "Zaffignano-La Fratta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;